import {NgModule} from '@angular/core';
import { DateTimePickerDirective } from './date-picker.directive';

@NgModule({
    declarations: [
        DateTimePickerDirective
    ],
    exports: [DateTimePickerDirective]
})

export class SntDatePicker {
}



// WEBPACK FOOTER //
// /opt/snt/front-end-turnos/src/app/turnos/shared/date-picker/date-picker.module.ts